type Callback = (...args: any[]) => void

export const debounce = (cb: Callback, delay: number) => {
  let timeoutId: ReturnType<typeof setTimeout>

  return (...args: any[]) => {
    clearTimeout(timeoutId)

    timeoutId = setTimeout(() => cb(...args), delay)
  }
}
